import { makeStyles } from '@material-ui/core';

export const styles = (theme) => ({

});

export default makeStyles(styles);